export default __webpack_public_path__ + "static/media/7minfitness@3x.d74df4a6.jpg";